import * as _indexOf from 'lodash/indexOf';
import * as _cloneDeep from 'lodash/cloneDeep';

const DeptDialogMixin = {
  data() {
    const cascaderValidator = (rule, value, callback) => {
      if (this.defaultCascader.indexOf(this.deptData.ID) > 0) {
        callback(new Error('上级部门不能为自身或者子部门'));
      } else {
        callback();
      }
    };
    return {
      // 控制修改部门信息dialog显隐
      editDeptVisible: false,
      // 存储修改部门信息
      editDeptData: {
        Name: '',
        ParentIDs: '',
        Members: [],
        Remark: '',
      },
      // 部门级联键名配置
      cascaderProp: {
        checkStrictly: true,
        value: 'ID',
        label: 'Name',
        children: 'Children',
      },
      // 控制编辑部门确定按钮
      deptSubmitDisable: false,
      // 编辑部门信息验证规则
      deptRules: {
        Name: [
          { required: true, message: '部门名称不能为空', trigger: 'change, blur' },
          { max: 50, message: '部门名称不能超过50个字符', trigger: 'change, blur' },
        ],
        ParentID: [{ required: true, validator: cascaderValidator, trigger: 'change, blur' }],
      },
      addDeptRules: {
        Name: [
          { required: true, message: '部门名称不能为空', trigger: 'change, blur' },
          { max: 50, message: '部门名称不能超过50个字符', trigger: 'change, blur' },
        ],
      },
      // 新增子部门
      addDeptVisible: false,
      // 存储添加子部门信息
      addDeptData: {
        Name: '',
        Remark: '',
      },
      // 控制新增子部门确定按钮
      addDeptSubmitDisable: false,
      // 移除的人员ids
      delMemberIds: [],
      // 新增的人员ids
      addMemberIds: [],
      // 原始的人员ids
      beforeMemberIds: [],
      // 最新的人员ids
      newMemberIds: [],
      editMemberVisible: false,
    };
  },
  methods: {
    // 点击编辑部门信息
    editDept() {
      this.editDeptVisible = true;
      this.editDeptData = {
        Name: this.deptData.Name,
        parentID: this.deptData.ParentID,
        Remark: this.deptData.Remark,
      };
    },
    // 编辑部门信息并上传
    editDeptSubmit() {
      this.$refs.editDeptForm.validate((valid) => {
        if (valid) {
          this.deptSubmitDisable = true;

          const uploadData = { ...this.editDeptData };
          if (this.editDeptData.ParentID) {
            uploadData.ParentID = this.defaultCascader[this.defaultCascader.length - 1];
          }
          this.$axios.put(`department/${this.deptData.ID}`, uploadData).then(() => {
            this.$message({
              showClose: true,
              message: '修改部门信息成功',
              type: 'success',
              duration: '1500',
            });
            this.deptSubmitDisable = false;
            this.$nextTick(() => {
              this.editDeptVisible = false;
              if (this.deptData.ParentID) {
                this.$emit('refresh', this.deptData.ID);
              } else {
                this.$emit('refresh');
              }
            });
          }, ({ response }) => {
            this.deptSubmitDisable = false;
            this.$sys.alarmResponse(response);
          });
        }
      });
    },
    // 删除部门
    deleteDept() {
      this.$confirm('是否删除该部门?', '请确定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => (
        this.$axios.delete(`department/${this.deptData.ID}`)
      )).then(() => {
        this.editDeptVisible = false;
        this.$emit('refresh', this.defaultCascader.pop());
        this.$message({
          showClose: true,
          message: '删除成功!',
          type: 'success',
          duration: '1500',
        });
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    // 添加子部门
    addDeptSubmit() {
      this.$refs.addDeptForm.validate((valid) => {
        if (valid) {
          this.addDeptSubmitDisable = true;
          this.addDeptData.ParentID = this.deptData.ID;
          let addDeptNew = {};
          addDeptNew = { ...this.addDeptData };
          this.$axios.post('department', { ...addDeptNew }).then(() => {
            if (this.deptData.ParentID) {
              this.$emit('refresh', this.deptData.ID);
            } else {
              this.$emit('refresh');
            }
            this.$message({
              showClose: true,
              message: '新增部门成功',
              type: 'success',
              duration: '1500',
            });
            this.addDeptVisible = false;
            this.addDeptSubmitDisable = false;
          }, ({ response }) => {
            this.addDeptSubmitDisable = false;
            this.$sys.alarmResponse(response);
          });
        }
      });
    },
    // 关闭后重置dialog
    resetDept() {
      setTimeout(() => {
        this.editDeptData = {
          Name: '',
          ParentID: '',
          managers: [],
          is_team: true,
        };
        this.setDefaultCascader(this.cascaderOptions);
      }, 0);
    },
    resetAddDept() {
      this.addDeptData = {
        Name: '',
        is_team: false,
      };
      this.$refs.addDeptForm.resetFields();
    },
    editMembers() {
      // 获取成员信息
      this.beforeMemberIds = this.deptData.Members ? this.deptData.Members.map(m => m.ID) : [];
      // 用于dialog显示及操作
      this.newMemberIds = _cloneDeep(this.beforeMemberIds);
      this.editMemberVisible = true;
    },
    resetEditMember() {
      this.beforeMemberIds = [];
      this.newMemberIds = [];
      this.delMemberIds = [];
      this.addMemberIds = [];
      // this.$refs.editMemberForm.resetFields();
    },
    editMember() {
      // 过滤出要要删除的用户id
      this.beforeMemberIds.forEach((ele) => {
        // 如果原始的数组中的id在新的中没找到，说明被删了
        if (_indexOf(this.newMemberIds, ele) === -1) {
          this.delMemberIds.push(ele);
        }
      });
      // 过滤出要添加的用户id
      this.newMemberIds.forEach((ele) => {
        // 如果新数组中的id在原始的中没找到，说明是新加的
        if (_indexOf(this.beforeMemberIds, ele) === -1) {
          this.addMemberIds.push(ele);
        }
      });
      // 批量删除该部门下的成员
      this.delAllMemberIds();
      // 批量添加该部门下的成员
      this.addAllMemberIds();
    },
    // 批量删除该部门下的成员
    delAllMemberIds() {
      const promiseAllDel = [];
      this.delMemberIds.forEach((ele) => {
        promiseAllDel.push(this.$axios.delete(`department/${this.deptData.ID}/user/${ele}`));
      });
      Promise.all(promiseAllDel).then(() => {
        if (this.deptData.ParentID) {
          this.$emit('refresh', this.deptData.ID);
        } else {
          this.$emit('refresh');
        }
      }, (response) => {
        this.$sys.alarmResponse(response);
      });
    },
    // 批量添加该部门下的成员
    addAllMemberIds() {
      const promiseAllAdd = [];
      this.addMemberIds.forEach(ele => promiseAllAdd
        .push(this.$axios.post(`department/${this.deptData.ID}/user/${ele}`)));
      Promise.all(promiseAllAdd).then(() => {
        if (this.deptData.ParentID) {
          this.$emit('refresh', this.deptData.ID);
        } else {
          this.$emit('refresh');
        }
        this.editMemberVisible = false;
      }, (response) => {
        this.editMemberVisible = false;
        this.$sys.alarmResponse(response);
      });
    },
  },
};
export default DeptDialogMixin;
